import { render, staticRenderFns } from "./MaydayNodeMainHeader.vue?vue&type=template&id=a42b8af2&scoped=true&"
import script from "./MaydayNodeMainHeader.vue?vue&type=script&lang=js&"
export * from "./MaydayNodeMainHeader.vue?vue&type=script&lang=js&"
import style0 from "./MaydayNodeMainHeader.vue?vue&type=style&index=0&id=a42b8af2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42b8af2",
  null
  
)

export default component.exports